import { FieldValidator } from 'final-form';

type ValidationConfig<T = unknown> = {
  input: string;
  rule: T;
  err_msg: string;
};

export const validateRequired = ({
  input,
  rule: is_required = true,
  err_msg,
}: ValidationConfig) => (is_required && input.length < 1 ? err_msg : undefined);

export const validateShorterThan = ({
  input = '',
  rule: min_len,
  err_msg,
}: ValidationConfig<number>) => (input.length < min_len ? undefined : err_msg);

export const validateLongerThan = ({
  input = '',
  rule: max_len,
  err_msg,
}: ValidationConfig<number>) => (input.length > max_len ? undefined : err_msg);

export const validateRegex = ({
  input = '',
  rule: regex,
  err_msg,
}: ValidationConfig<RegExp>) =>
  input.length > 0 && !regex.test(input) ? err_msg : undefined;

export const validateExclusionaryRegex = ({
  input = '',
  rule: regex,
  err_msg,
}: ValidationConfig<RegExp>) =>
  input.length > 0 && input.match(regex) !== null ? err_msg : undefined;

const MIN_PHONE_LENGTH = 10;

export const validatePhoneNumber = ({
  input = '',
  rule: regex,
  err_msg,
}: ValidationConfig<RegExp>) => {
  const digits = input.match(regex);
  return input.length > 0 && digits !== null && digits.length < MIN_PHONE_LENGTH
    ? err_msg
    : undefined;
};

export const composeTextFieldValidators =
  <T = string>(...validators: FieldValidator<T>[]) =>
  (value: T) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

/**
 * This allows us to abstract the form state validity away of react-final-form, which
 * is useful for niche cases. For example, form state may be invalid from mount (ie:
 * field is blank but required), but we don't want to render the validation error
 * until the user has attempted to submit.
 */
export const resolveFieldError = (
  form_state_valid: boolean,
  {
    touched,
    error,
  }: {
    touched?: boolean;
    error?: string;
  }
) => {
  if ((!form_state_valid && error) || (touched && error)) {
    return error;
  }
};
